/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'

const CustomPills = ({ value, onSubmit, index, options, id }) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <button
      style={{ border: 'none', background: 'transparent' }}
      onClick={() =>
        onSubmit({
          id,
          trackingCode: Array.isArray(options) && options.length > 0 && options[index].pageValue,
          value: options[index].value,
        })
      }>
      <h3
        style={{
          border: '2px solid #0baf20',
          borderRadius: '30px',
          cursor: 'pointer',
          padding: '0.5rem',
          fontSize: '0.8rem',
        }}>
        {value}
      </h3>
    </button>
  )
}

export default CustomPills
